import chart from "@/views/panel/layout/AppIcons/chart";
import donutQty from "@/views/panel/layout/AppIcons/donutQty";
import dropDown from "@/views/panel/layout/AppIcons/dropDown";
import excelIcon from "@/views/panel/layout/AppIcons/excelIcon";
import excelIconHover from "@/views/panel/layout/AppIcons/excelIconHover";
import fullScreenArrow from "@/views/panel/layout/AppIcons/fullScreenArrow";
import giftIcon from "@/views/panel/layout/AppIcons/giftIcon";
import infoIcon from "@/views/panel/layout/AppIcons/infoIcon";
import listCheck from "@/views/panel/layout/AppIcons/listCheck";
import logo from "@/views/panel/layout/AppIcons/logo";
import darkLogo from "@/views/panel/layout/AppIcons/darkLogo";
import modalClose from "@/views/panel/layout/AppIcons/modalClose";
import notificationIcon from "@/views/panel/layout/AppIcons/notificationIcon";
import orderHistoryIcon from "@/views/panel/layout/AppIcons/orderHistoryIcon";
import setTime from "@/views/panel/layout/AppIcons/setTime";
import supportIcon from "@/views/panel/layout/AppIcons/supportIcon";
import tableBack from "@/views/panel/layout/AppIcons/tableBack";
import tableNext from "@/views/panel/layout/AppIcons/tableNext";
import tradIcon from "@/views/panel/layout/AppIcons/tradIcon";
import userArrow from "@/views/panel/layout/AppIcons/userArrow";
import userIcon from "@/views/panel/layout/AppIcons/userIcon";
import walletIcon from "@/views/panel/layout/AppIcons/walletIcon";
import watchListIcon from "@/views/panel/layout/AppIcons/watchListIcon";
import favoriteStar from "@/views/panel/layout/AppIcons/favoriteStar";
import search from "@/views/panel/layout/AppIcons/search";
import coin from "@/views/panel/layout/AppIcons/coin";
import downSymbol from "@/views/panel/layout/AppIcons/downSymbol";
import upSymbol from "@/views/panel/layout/AppIcons/upSymbol";
import approximation from "@/views/panel/layout/AppIcons/approximation";
import lightMode from "@/views/panel/layout/AppIcons/lightMode";
import newTradeIcon from "@/views/panel/layout/AppIcons/newTradeIcon";
import upSort from "@/views/panel/layout/AppIcons/upSort";
import sortIcon from "@/views/panel/layout/AppIcons/sort";
import messagesChat from "@/views/panel/layout/AppIcons/messagesChat";
import faqMail from "@/views/panel/layout/AppIcons/faqMail";
import phone from "@/views/panel/layout/AppIcons/phone";
import arrow from "@/views/panel/layout/AppIcons/arrow";
import arrowBack from "@/views/panel/layout/AppIcons/arrowBack";
import clipAttachment from "@/views/panel/layout/AppIcons/clipAttachment";
import clipAttachmentPrimary from "@/views/panel/layout/AppIcons/clipAttachmentPrimary";
import userProfileAvatar from "@/views/panel/layout/AppIcons/userProfileAvatar";
import sendMessage from "@/views/panel/layout/AppIcons/sendMessage";
import lockModal from "@/views/panel/layout/AppIcons/lockModal";
import warning from "@/views/panel/layout/AppIcons/warning";
import lock from "@/views/panel/layout/AppIcons/lock";
import bellNotification from "@/views/panel/layout/AppIcons/bellNotification";
import bullet from "@/views/panel/layout/AppIcons/bullet";
import closeNotification from "@/views/panel/layout/AppIcons/closeNotification";
import notification from "@/views/panel/layout/AppIcons/notification";
import penEdit from "@/views/panel/layout/AppIcons/penEdit";
import updateIcon from "@/views/panel/layout/AppIcons/updateIcon";
import checkboxCheck from "@/views/panel/layout/AppIcons/checkboxCheck";
import moveIcon from "@/views/panel/layout/AppIcons/moveIcon";
import closeIcon from "@/views/panel/layout/AppIcons/closeIcon";
import refreshIcon from "@/views/panel/layout/AppIcons/refreshIcon";
import downSort from "@/views/panel/layout/AppIcons/downSort";
import dropDownTable from "@/views/panel/layout/AppIcons/dropDownTable";
import back from "@/views/panel/layout/AppIcons/back";
import checkMarkCircle from "@/views/panel/layout/AppIcons/checkMarkCircle";
import excel from "@/views/panel/layout/AppIcons/excel";
import plusAdd from "@/views/panel/layout/AppIcons/plusAdd";
import rotateRefreshLoading from "@/views/panel/layout/AppIcons/rotateRefreshLoading";
import settingsFilter from "@/views/panel/layout/AppIcons/settingsFilter";
import calendarSchedule from "@/views/panel/layout/AppIcons/calendarSchedule";
import defaultSort from "@/views/panel/layout/AppIcons/defaultSort";
import approve from "@/views/panel/layout/AppIcons/approve";
import contact from "@/views/panel/layout/AppIcons/contact";
import documentLegalUsers from "@/views/panel/layout/AppIcons/documentLegalUsers";
import noApprove from "@/views/panel/layout/AppIcons/noApprove";
import selfiePhoto from "@/views/panel/layout/AppIcons/selfiePhoto";
import creditCard from "@/views/panel/layout/AppIcons/creditCard";
import iphoneMobile from "@/views/panel/layout/AppIcons/iphoneMobile";
import trashBin from "@/views/panel/layout/AppIcons/trashBin";
import userProfileCircle from "@/views/panel/layout/AppIcons/userProfileCircle";
import lockPasswordInput from "@/views/panel/layout/AppIcons/lockPasswordInput";
import eyeShow from "@/views/panel/layout/AppIcons/eyeShow";
import googlePlay from "@/views/panel/layout/AppIcons/googlePlay";
import appStore from "@/views/panel/layout/AppIcons/appStore";
import downloadSaveUpload from "@/views/panel/layout/AppIcons/downloadSaveUpload";
import floppySave from "@/views/panel/layout/AppIcons/floppySave";
import scrollDownCircle from "@/views/panel/layout/AppIcons/scrollDownCircle";
import dashboardIcon from "@/views/panel/layout/AppIcons/dashboardIcon";
import arrow2 from "@/views/panel/layout/AppIcons/arrow2";
import alarmClockTimeWarning from "@/views/panel/layout/AppIcons/alarmClockTimeWarning";
import Arrow16 from "@/views/panel/layout/AppIcons/Arrow16";
import cancelOrder from "@/views/panel/layout/AppIcons/cancelOrder";
import changeReplace from "@/views/panel/layout/AppIcons/changeReplace";
import checkMarkCircleWallet from "@/views/panel/layout/AppIcons/checkMarkCircleWallet";
import checkMarkCircleSuccess from "@/views/panel/layout/AppIcons/checkMarkCircleSuccess";
import checkMarkCirclePrimary from "@/views/panel/layout/AppIcons/checkMarkCirclePrimary";
import copy from "@/views/panel/layout/AppIcons/copy";
import doneCheck from "@/views/panel/layout/AppIcons/doneCheck";
import down from "@/views/panel/layout/AppIcons/down";
import penEditWallet from "@/views/panel/layout/AppIcons/penEditWallet";
import plusAddWallet from "@/views/panel/layout/AppIcons/plusAddWallet";
import qrCode from "@/views/panel/layout/AppIcons/qrCode";
import receipt from "@/views/panel/layout/AppIcons/receipt";
import receiptPlusPrimary from "@/views/panel/layout/AppIcons/receiptPlusPrimary";
import receiptPlus from "@/views/panel/layout/AppIcons/receiptPlus";
import save from "@/views/panel/layout/AppIcons/save";
import share from "@/views/panel/layout/AppIcons/share";
import smsIcon from "@/views/panel/layout/AppIcons/smsIcon";
import smsIconPrimary from "@/views/panel/layout/AppIcons/smsIconPrimary";
import trashDeleteBin from "@/views/panel/layout/AppIcons/trashDeleteBin";
import trashDeleteBinGrey from "@/views/panel/layout/AppIcons/trashDeleteBinGrey";
import userVerify from "@/views/panel/layout/AppIcons/userVerify";
import WageUp from "@/views/panel/layout/AppIcons/WageUp";
import walletAddress from "@/views/panel/layout/AppIcons/walletAdress";
import warningWallet from "@/views/panel/layout/AppIcons/warningWallet";
import QrCodeWallet from "@/views/panel/layout/AppIcons/QrCodeWallet";
import arrowFront from "@/views/panel/layout/AppIcons/arrowFront";
import pendingCircle from "@/views/panel/layout/AppIcons/pendingCircle";
import pending from "@/views/panel/layout/AppIcons/pending";
import disabled from "@/views/panel/layout/AppIcons/disabled";
import Smileys from "@/views/panel/layout/AppIcons/Smileys";
import TransactionEmptyIcon from "@/views/panel/layout/AppIcons/TransactionEmptyIcon";
import verifiedIcon2 from "@/views/panel/layout/AppIcons/verifiedIcon2";
import moon from "@/views/panel/layout/AppIcons/moon";
import verifiedIcon from "@/views/panel/layout/AppIcons/verifiedIcon";
import arrow24 from "@/views/panel/layout/AppIcons/arrow24";
import userVerifyPrimary from "@/views/panel/layout/AppIcons/userVerifyPrimary";
import bankCustomer from "@/views/panel/layout/AppIcons/bankCustomer";
import shieldProtected from "@/views/panel/layout/AppIcons/shieldProtected";
import eyeHidden from "@/views/panel/layout/AppIcons/eyeHidden";
import arrowDown from "@/views/panel/layout/AppIcons/arrowDown";
import passCheck from "@/views/panel/layout/AppIcons/passCheck";
import passUncheck from "@/views/panel/layout/AppIcons/passUncheck";
import exit from "@/views/panel/layout/AppIcons/exitIcon";
import deleteSearch from "@/views/panel/layout/AppIcons/deleteSearch";
import helpWheel from "@/views/panel/layout/AppIcons/helpWheel";
import depositIcon from "@/views/panel/layout/AppIcons/DepositIcon";
import exchangeIcon from "@/views/panel/layout/AppIcons/exchangeIcon";
import withdrawIcon from "@/views/panel/layout/AppIcons/withdrawIcon";
import arrowLeft from "@/views/panel/layout/AppIcons/arrowLeft";
import cardList from "@/views/panel/layout/AppIcons/cardList";
import documentEditPen from "@/views/panel/layout/AppIcons/documetEditPen";
import openIcon from "@/views/panel/layout/AppIcons/openIcon";
import watchClockTime from "@/views/panel/layout/AppIcons/watchClockTime";
import doneCheck2 from "@/views/panel/layout/AppIcons/doneCheck2";
import ArrowBackPerfectMoney from "@/views/panel/layout/AppIcons/ArrowBackPerfectMoney";
import PerfectIcon from "@/views/panel/layout/AppIcons/PerfectIcon";
import emailVerified from "@/views/panel/layout/AppIcons/emailVerified";
import emailSuccess from "@/views/panel/layout/AppIcons/emailSuccess";
import emailInvalid from "@/views/panel/layout/AppIcons/emailInvalid";
import mobileDevicesRotate from "@/views/panel/layout/AppIcons/mobileDevicesRotate";
import unmatchedCard from "@/views/panel/layout/AppIcons/Unmatchcard";
import Ellipse from "@/views/panel/layout/AppIcons/Ellipse";
import marketLogo from "@/views/panel/layout/AppIcons/marketLogo";
import walletSetting from "@/views/panel/layout/AppIcons/settings";
import priceList from "@/views/panel/layout/AppIcons/PriceList";
import referral from "@/views/panel/layout/AppIcons/Referral";
import clock from "@/views/panel/layout/AppIcons/clock";
import giftSticker from "@/views/panel/layout/AppIcons/giftSticker";
import upload from "@/views/panel/layout/AppIcons/upload";
import add from "@/views/panel/layout/AppIcons/add";
import fastVerify from "@/views/panel/layout/AppIcons/Fast_verify";
import googleAuth from "@/views/panel/layout/AppIcons/Google";
import passwordLock from "@/views/panel/layout/AppIcons/password-lock";
import world from "@/views/panel/layout/AppIcons/world";
import darkMode from "@/views/panel/layout/AppIcons/darkMode";
import mainLogo from "@/views/panel/layout/AppIcons/mainLogo";
import camera from "@/views/panel/layout/AppIcons/camera";
import webCam from "@/views/panel/layout/AppIcons/webCam";
import kycIcon from "@/views/panel/layout/AppIcons/kycIcon";
import normalVerify from "@/views/panel/layout/AppIcons/noramlVerify";
import strockTik from "@/views/panel/layout/AppIcons/StrockTik";
import rejectIcon from "@/views/panel/layout/AppIcons/rejectIcon";
import imageProccessing from "@/views/panel/layout/AppIcons/imageProccessing";
import editIcon from "@/views/panel/layout/AppIcons/editIcon";
import darkMainLogo from "@/views/panel/layout/AppIcons/darkMainLogo";
import Play from "@/views/panel/layout/AppIcons/play";
import zoomOut from "@/views/panel/layout/AppIcons/zoomOut";
import rotateIcon from "@/views/panel/layout/AppIcons/rotateIcon";
import flipIcon from "@/views/panel/layout/AppIcons/flipIcon";
import zoomIn from "@/views/panel/layout/AppIcons/zoomIn";
import verifiedShield from "@/views/panel/layout/AppIcons/verifiedShield";
import deleteIcon from "@/views/panel/layout/AppIcons/deleteIcon";
import getFromGoogle from "@/views/panel/layout/AppIcons/getFromGoogle";
import getDirectAPK from "@/views/panel/layout/AppIcons/getDirectAPK";
import getFromSibapp from "@/views/panel/layout/AppIcons/getFromSibapp";
import getFromBazar from "@/views/panel/layout/AppIcons/getFromBazar";
import uploadCard from "@/views/panel/layout/AppIcons/uploadCard";
import record from "@/views/panel/layout/AppIcons/record";
import stopRecord from "@/views/panel/layout/AppIcons/stopRecord";
import paymentIDEmpty from "@/views/panel/layout/AppIcons/paymentIDEmpty";
import questionWarning from "@/views/panel/layout/AppIcons/questionWarning";
import addPhoto from "@/views/panel/layout/AppIcons/addPhoto";
import captureButton from "@/views/panel/layout/AppIcons/captureButton";
import investment from "@/views/panel/layout/AppIcons/Investment";
import demoTrading from "@/views/panel/layout/AppIcons/demoTrading";
import discountCode from "@/views/panel/layout/AppIcons/discountCode";
import language from "@/views/panel/layout/AppIcons/language";
import mainWallet from "@/views/panel/layout/AppIcons/mainWallet.vue";
import spotWallet from "@/views/panel/layout/AppIcons/spotWallet.vue";
import fastConvert from "@/views/panel/layout/AppIcons/fastConvert.vue";
import ordering from "@/views/panel/layout/AppIcons/ordering.vue";
import perfectMoney from "@/views/panel/layout/AppIcons/perfectMoney.vue";
import spotMarket from "@/views/panel/layout/AppIcons/spotMarket.vue";
import testSpot from "@/views/panel/layout/AppIcons/testSpot.vue";
import openOrders from "@/views/panel/layout/AppIcons/openOrders.vue";
import profitLossLimit from "@/views/panel/layout/AppIcons/profitLossLimit.vue";
import history from "@/views/panel/layout/AppIcons/history.vue";
import openOrdersHistory from "@/views/panel/layout/AppIcons/openOrdersHistory.vue";
import profitLossLimitHistory from "@/views/panel/layout/AppIcons/profitLossLimitHistory.vue";
import transactionsHistory from "@/views/panel/layout/AppIcons/transactionsHistory.vue";
import staking from "@/views/panel/layout/AppIcons/staking.vue";
import partnershipFunds from "@/views/panel/layout/AppIcons/partnershipFunds.vue";
import uranus from "@/views/panel/layout/AppIcons/uranus.vue";
import plateAll from "@/views/panel/layout/AppIcons/plateAll.vue";
import transferIcon from "@/views/panel/layout/AppIcons/transferIcon.vue";
import sidebarMainWallet from "@/views/panel/layout/AppIcons/sidebarMainWallet.vue";
import sidebarSpotWallet from "@/views/panel/layout/AppIcons/sidebarSpotWallet.vue";
import sidebarPortfolio from "@/views/panel/layout/AppIcons/sidebarPortfolio.vue";
import sidebarDeposit from "@/views/panel/layout/AppIcons/sidebarDeposit.vue";
import sidebarExchange from "@/views/panel/layout/AppIcons/sidebarExchange.vue";
import sidebarWithdraw from "@/views/panel/layout/AppIcons/sidebarWithdraw.vue";
import sidebarTransfer from "@/views/panel/layout/AppIcons/sidebarTransfer.vue";
import CheckIcon from "@/views/panel/layout/AppIcons/CheckIcon.vue";
import GoogleAuthIcon from "@/views/panel/layout/AppIcons/GoogleAuth.vue"
import ManualIcon from "@/views/panel/layout/AppIcons/ManualIcon.vue";

const CustomIcons = {
  paymentIDEmpty: {
    component: paymentIDEmpty
  },
  demoTrading: {
    component: demoTrading
  },
  investment: {
    component: investment
  },
  captureButton: {
    component: captureButton
  },
  addPhoto: {
    component: addPhoto
  },
  questionWarning: {
    component: questionWarning
  },
  mainLogo: {
    component: mainLogo
  },
  darkMainLogo: {
    component: darkMainLogo
  },
  darkMode: {
    component: darkMode
  },
  world: {
    component: world
  },
  passwordLock: {
    component: passwordLock
  },
  googleAuth: {
    component: googleAuth
  },
  fastVerify: {
    component: fastVerify
  },
  priceList: {
    component: priceList
  },
  walletSetting: {
    component: walletSetting
  },
  giftSticker: {
    component: giftSticker
  },
  emailVerified: {
    component: emailVerified
  },
  marketLogo: {
    component: marketLogo
  },
  Ellipse: {
    component: Ellipse
  },
  unmatchedCard: {
    component: unmatchedCard
  },
  mobileDevicesRotate: {
    component: mobileDevicesRotate
  },
  emailSuccess: {
    component: emailSuccess
  },
  emailInvalid: {
    component: emailInvalid
  },
  dashboardIcon: {
    component: dashboardIcon
  },
  ArrowBackPerfectMoney: {
    component: ArrowBackPerfectMoney
  },
  PerfectIcon: {
    component: PerfectIcon
  },
  depositIcon: {
    component: depositIcon
  },
  withdrawIcon: {
    component: withdrawIcon
  },
  exchangeIcon: {
    component: exchangeIcon
  },
  helpWheel: {
    component: helpWheel
  },
  arrow2: {
    component: arrow2
  },
  arrowLeft: {
    component: arrowLeft
  },
  doneCheck2: {
    component: doneCheck2
  },
  cardList: {
    component: cardList
  },
  watchClockTime: {
    component: watchClockTime
  },
  openIcon: {
    component: openIcon
  },
  documentEditPen: {
    component: documentEditPen
  },
  shieldProtected: {
    component: shieldProtected
  },
  bankCustomer: {
    component: bankCustomer
  },
  userVerifyPrimary: {
    component: userVerifyPrimary
  },
  arrow24: {
    component: arrow24
  },
  verifiedIcon: {
    component: verifiedIcon
  },
  moon: {
    component: moon
  },
  verifiedIcon2: {
    component: verifiedIcon2
  },
  disabled: {
    component: disabled
  },
  pending: {
    component: pending
  },
  pendingCircle: {
    component: pendingCircle
  },
  exit: {
    component: exit
  },
  passUncheck: {
    component: passUncheck
  },
  passCheck: {
    component: passCheck
  },
  arrowDown: {
    component: arrowDown
  },
  scrollDownCircle: {
    component: scrollDownCircle
  },
  deleteSearch: {
    component: deleteSearch
  },
  Smileys: {
    component: Smileys
  },
  QrCodeWallet: {
    component: QrCodeWallet
  },
  warningWallet: {
    component: warningWallet
  },
  walletAddress: {
    component: walletAddress
  },
  WageUp: {
    component: WageUp
  },
  plusAddWallet: {
    component: plusAddWallet
  },
  userVerify: {
    component: userVerify
  },
  trashDeleteBin: {
    component: trashDeleteBin
  },
  trashDeleteBinGrey: {
    component: trashDeleteBinGrey
  },
  smsIcon: {
    component: smsIcon
  },
  smsIconPrimary: {
    component: smsIconPrimary
  },
  share: {
    component: share
  },
  save: {
    component: save
  },
  receiptPlus: {
    component: receiptPlus
  },
  receipt: {
    component: receipt
  },
  receiptPlusPrimary: {
    component: receiptPlusPrimary
  },
  down: {
    component: down
  },
  penEditWallet: {
    component: penEditWallet
  },
  alarmClockTimeWarning: {
    component: alarmClockTimeWarning
  },
  cancelOrder: {
    component: cancelOrder
  },
  checkMarkCircleWallet: {
    component: checkMarkCircleWallet
  },
  checkMarkCirclePrimary: {
    component: checkMarkCirclePrimary
  },
  checkMarkCircleSuccess: {
    component: checkMarkCircleSuccess
  },
  copy: {
    component: copy
  },
  changeReplace: {
    component: changeReplace
  },
  Arrow16: {
    component: Arrow16
  },
  TransactionEmptyIcon: {
    component: TransactionEmptyIcon
  },
  arrowFront: {
    component: arrowFront
  },
  doneCheck: {
    component: doneCheck
  },
  downloadSaveUpload: {
    component: downloadSaveUpload
  },
  floppySave: {
    component: floppySave
  },
  qrCode: {
    component: qrCode
  },
  googlePlay: {
    component: googlePlay
  },
  appStore: {
    component: appStore
  },
  eyeShow: {
    component: eyeShow
  },
  eyeHidden: {
    component: eyeHidden
  },
  lockPasswordInput: {
    component: lockPasswordInput
  },
  userProfileCircle: {
    component: userProfileCircle
  },
  trashBin: {
    component: trashBin
  },
  iphoneMobile: {
    component: iphoneMobile
  },
  creditCard: {
    component: creditCard
  },
  approve: {
    component: approve
  },
  contact: {
    component: contact
  },
  documentLegalUsers: {
    component: documentLegalUsers
  },
  noApprove: {
    component: noApprove
  },
  selfiePhoto: {
    component: selfiePhoto
  },
  moveIcon: {
    component: moveIcon
  },
  calendarSchedule: {
    component: calendarSchedule
  },
  back: {
    component: back
  },
  checkMarkCircle: {
    component: checkMarkCircle
  },
  settingsFilter: {
    component: settingsFilter
  },
  rotateRefreshLoading: {
    component: rotateRefreshLoading
  },
  plusAdd: {
    component: plusAdd
  },
  excel: {
    component: excel
  },
  defaultSort: {
    component: defaultSort
  },
  dropDownTable: {
    component: dropDownTable
  },
  downSort: {
    component: downSort
  },
  closeIcon: {
    component: closeIcon
  },
  refreshIcon: {
    component: refreshIcon
  },
  checkboxCheck: {
    component: checkboxCheck
  },
  chart: {
    component: chart
  },
  bellNotification: {
    component: bellNotification
  },
  bullet: {
    component: bullet
  },
  closeNotification: {
    component: closeNotification
  },
  notification: {
    component: notification
  },
  penEdit: {
    component: penEdit
  },
  updateIcon: {
    component: updateIcon
  },
  upSort: {
    component: upSort
  },
  sortIcon: {
    component: sortIcon
  },
  newTradeIcon: {
    component: newTradeIcon
  },
  donutQty: {
    component: donutQty
  },
  dropDown: {
    component: dropDown
  },
  excelIcon: {
    component: excelIcon
  },
  excelIconHover: {
    component: excelIconHover
  },
  fullScreenArrow: {
    component: fullScreenArrow
  },
  giftIcon: {
    component: giftIcon
  },
  infoIcon: {
    component: infoIcon
  },
  listCheck: {
    component: listCheck
  },
  logo: {
    component: logo
  },
  darkLogo: {
    component: darkLogo
  },
  modalClose: {
    component: modalClose
  },
  notificationIcon: {
    component: notificationIcon
  },
  orderHistoryIcon: {
    component: orderHistoryIcon
  },
  setTime: {
    component: setTime
  },
  supportIcon: {
    component: supportIcon
  },
  tableBack: {
    component: tableBack
  },
  tableNext: {
    component: tableNext
  },
  tradIcon: {
    component: tradIcon
  },
  userArrow: {
    component: userArrow
  },
  userIcon: {
    component: userIcon
  },
  walletIcon: {
    component: walletIcon
  },
  watchListIcon: {
    component: watchListIcon
  },
  favoriteStar: {
    component: favoriteStar
  },
  search: {
    component: search
  },
  coin: {
    component: coin
  },
  upSymbol: {
    component: upSymbol
  },
  downSymbol: {
    component: downSymbol
  },
  approximation: {
    component: approximation
  },
  lightMode: {
    component: lightMode
  },
  messagesChat: {
    component: messagesChat
  },
  faqMail: {
    component: faqMail
  },
  phone: {
    component: phone
  },
  arrow: {
    component: arrow
  },
  arrowBack: {
    component: arrowBack
  },
  userProfileAvatar: {
    component: userProfileAvatar
  },
  clipAttachment: {
    component: clipAttachment
  },
  clipAttachmentPrimary: {
    component: clipAttachmentPrimary
  },
  sendMessage: {
    component: sendMessage
  },
  lockModal: {
    component: lockModal
  },
  warning: {
    component: warning
  },
  lock: {
    component: lock
  },
  clock: {
    component: clock
  },
  upload: {
    component: upload
  },
  add: {
    component: add
  },
  referral: {
    component: referral
  },
  camera: {
    component: camera
  },
  webCam: {
    component: webCam
  },
  kycIcon: {
    component: kycIcon
  },
  normalVerify: {
    component: normalVerify
  },
  strockTik: {
    component: strockTik
  },
  rejectIcon: {
    component: rejectIcon
  },
  imageProccessing: {
    component: imageProccessing
  },
  editIcon: {
    component: editIcon
  },
  play: {
    component: Play
  },
  zoomOut: {
    component: zoomOut
  },
  zoomIn: {
    component: zoomIn
  },
  rotateIcon: {
    component: rotateIcon
  },
  flipIcon: {
    component: flipIcon
  },
  verifiedShield: {
    component: verifiedShield
  },
  deleteIcon: {
    component: deleteIcon
  },
  getFromGoogle: {
    component: getFromGoogle
  },
  getDirectAPK: {
    component: getDirectAPK
  },
  getFromBazar: {
    component: getFromBazar
  },
  getFromSibapp: {
    component: getFromSibapp
  },
  uploadCard: {
    component: uploadCard
  },
  record: {
    component: record
  },
  stopRecord: {
    component: stopRecord
  },
  discountCode: {
    component: discountCode
  },
  languageIcon: {
    component: language
  },
  spotWallet: {
    component: spotWallet
  },
  mainWallet: {
    component: mainWallet
  },
  fastConvert: {
    component: fastConvert
  },
  ordering: {
    component: ordering
  },
  perfectMoney: {
    component: perfectMoney
  },
  spotMarket: {
    component: spotMarket
  },
  testSpot: {
    component: testSpot
  },
  openOrders: {
    component: openOrders
  },
  profitLossLimit: {
    component: profitLossLimit
  },
  history: {
    component: history
  },
  openOrdersHistory: {
    component: openOrdersHistory
  },
  profitLossLimitHistory: {
    component: profitLossLimitHistory
  },
  transactionsHistory: {
    component: transactionsHistory
  },
  staking: {
    component: staking
  },
  partnershipFunds: {
    component: partnershipFunds
  },
  uranus: {
    component: uranus
  },
  plateAll: {
    component: plateAll
  },
  transferIcon: {
    component: transferIcon
  },
  sidebarMainWallet: {
    component: sidebarMainWallet
  },
  sidebarSpotWallet: {
    component: sidebarSpotWallet
  },
  sidebarPortfolio: {
    component: sidebarPortfolio
  },
  sidebarExchange: {
    component: sidebarExchange
  },
  sidebarDeposit: {
    component: sidebarDeposit
  },
  sidebarWithdraw: {
    component: sidebarWithdraw
  },
  sidebarTransfer: {
    component: sidebarTransfer
  },
  checkIcon:{
    component: CheckIcon
  },
  googleAuthIcon:{
    component: GoogleAuthIcon
  },
  manualIcon:{
    component:ManualIcon
  }
};

export default CustomIcons;
